import * as React from 'react';
import { AutoComplete, ListItemProps } from '@progress/kendo-react-dropdowns';
import { fetchApi } from '../../services/api';
import * as moment from 'moment';

type Props = {
    callbackFromParent: (data: ChildSearchResult) => void;
    classroomId?: number;
    className?: string;
    style?: {};
};

type State = {
    value: string;
    loading: boolean;
    opened: boolean;
    childResults: ChildSearchResult[];
}

export interface ChildSearchResult {
    ChildId: number;
    ChildName: string;
    FacilityName: string;
    AccountName: string;
    Birthday: Date,
    FacilityId: number;
}

export default class ChildAutoComplete extends React.Component<Props, State> {

    private timeout!: NodeJS.Timeout;

    constructor(props: Props) {
        super(props);

        this.state = {
            value: '',
            loading: false,
            opened: false,
            childResults: [],
        };
    };

    itemRender = (li: any, itemProps: ListItemProps) => {
        const itemChildren = <span style={{ fontSize: "14px" }}>{itemProps.dataItem.ChildName + " (" + itemProps.dataItem.AccountName + ") DOB: " + moment.utc(itemProps.dataItem.Birthday).format("YYYY-MM-DD")}</span>;

        return React.cloneElement(li, li.props, itemChildren);
    }

    onChange = (event: any) => {
        const eventType = event.nativeEvent.type;
        const valueSelected = eventType === 'click' ||
            (eventType === 'keydown' && event.nativeEvent.keyCode === 13);

        if (valueSelected) {
            let data: ChildSearchResult = event.target.value;
            this.props.callbackFromParent(data);
            this.setState({
                value: data.ChildName
            });
        } else {
            if (event.target.value.trim().length > 0) {
                clearTimeout(this.timeout);

                this.setState({
                    value: event.target.value,
                    loading: true
                });

                this.timeout = setTimeout(() => {
                    this.filterData(event.target.value);
                }, 500);

            } else {
                this.setState({
                    value: event.target.value,
                    loading: false
                });
            }
        }
    }

    filterData(value: string) {
        const requestData = {
            ClassroomId: this.props.classroomId,
            SearchTerm: value,
            FacilityID: localStorage.getItem("FACILITY_ID")
        }
        fetchApi('/api/Classrooms/ChildSearch', requestData, 'POST')
            .then((results: ChildSearchResult[]) => {
                this.setState({ childResults: results, loading: false });
            });
    }

    public render() {
        return (
            <AutoComplete
                data={this.state.childResults}
                value={this.state.value}
                onChange={this.onChange}
                loading={this.state.loading}
                style={this.props.style}
                itemRender={this.itemRender}
                className={this.props.className}
                placeholder="Child Search"
            />
        );
    }
}
